const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaLog: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'COMPROVANTE_ENTREGA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'COMPROVANTE_ENTREGA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};
		
		case 'COMPROVANTE_ENTREGA_LOG_LISTADO':
			return {
				...state,
				listaLog: action.payload.data
			};

        default:
            return state;
    }
}
